import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { api } from "@/lib/api";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { StayPoolside } from "./StayPoolside";
import { SubscribePopup } from "./SubscribePopup";

export function SiteLayout() {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    api
      .get("/content/announcements")
      .then((r) => {
        const active = (r.data || []).find((a) => a.active);
        if (active) setAnnouncement(active);
      })
      .catch(() => {});
  }, []);

  return (
    <div>
      {announcement && (
        <div
          data-testid="announcement-bar"
          className="bg-pool text-white text-center text-[11px] sm:text-xs tracking-[0.18em] uppercase font-semibold py-2.5 px-4"
        >
          {announcement.link ? (
            <a href={announcement.link} target="_blank" rel="noreferrer" className="hover:underline">
              {announcement.text}
            </a>
          ) : (
            announcement.text
          )}
        </div>
      )}
      <Header />
      <main>
        <Outlet />
      </main>
      <StayPoolside />
      <SubscribePopup />
      <Footer />
    </div>
  );
}
